import http from "./http-common";

class AppointmentService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }

  TodayAppointment(payload) {
    return http.get(
      `/patientAppointment/list/filter?fromDate=${payload.fromDate}&toDate=${payload.toDate}`
    );
  }

  AppointmentList(payload) {
    return http.get(`/patientAppointment/list/filter`, payload);
  }

  AppointmentType(value) {
    return http.get(`/patientAppointment/list/filter?serviceCode=${value}`);
  }

  AppointmentFilter(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return http.get(`/patientAppointment/list/filter?${queryString}`);
  }

  GetQeueCount(payload) {
    const queryString = Object.entries(payload)
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return http.get(`/patientAppointment/getAppointmentCounts?${queryString}`);
  }

  GetAppointmentId(id) {
    return http.get(`invitationDetails/list/filter?appointmentId=${id}`);
  }

  AppointmentCancel(id) {
    return http.put(`/patientAppointment/cancel?appointmentId=${id}`);
  }

  AppointmentCancelNew(payload) {
    return http.put(`/patientAppointment/cancel`, payload);
  }

  AppointmentUpdate(data) {
    return http.put(`/invitationDetails/update-status/${data.id}`, data);
  }

  AppointmentReschedule(data) {
    return http.put(`/patientAppointment/update/appointment-reschedule`, data);
  }

  AllConsReasons(data) {
    const queryString = this.queryString(data);
    return http.get(
      `/ChiefComplaintMaster/list/filter?pageNo=1&pageSize=30&${queryString}`
    );
  }

  ListForCalendar(data) {
    const queryString = this.queryString(data);
    return http.get(
      `/patientAppointment/listForCalendar/filter?${queryString}`
    );
  }

  GetWalletMoney(data) {
    const queryString = this.queryString(data);
    return http.get(`/Wallet/getWallet?${queryString}`);
  }
}
export default new AppointmentService();
